import(/* webpackMode: "eager" */ "/opt/build/repo/src/page-contact/page-contact-view.tsx")